<div class="input-material pr-5">
    <input id="dateRange" [disabled]="disabled" type="text" inputmode="numeric" class="form-control" autocomplete="off"
           daterangepicker [options]="options" (selected)="selectRange($event)"/>
    <label for="dateRange" [ngClass]="{'disabled': disabled}">{{label}}</label>
    <svg-icon svgClass="icon_date" src="assets/svg/calendar.svg"></svg-icon>
</div>
